export default __webpack_public_path__ + "static/media/M3.4e3ce646.pdf";